(() => {
  const setText = (root, selector, value) => {
    const element = root.querySelector(selector);
    if (element) element.textContent = value;
  };

  const setStep = (card, label, headline, body) => {
    if (!card) return;

    const meta = card.querySelector('.ps-step__meta');
    if (meta) {
      const dot = document.createElement('span');
      dot.setAttribute('aria-hidden', 'true');
      meta.replaceChildren(dot, document.createTextNode(` ${label}`));
    }

    setText(card, 'h3', headline);

    const description = Array.from(card.children).find(
      (element) => element.tagName === 'P' && !element.classList.contains('ps-step__meta')
    );
    if (description) description.textContent = body;
  };

  const how = document.querySelector('.ps-how--player');
  if (how) {
    setText(how, '.ps-heading .ps-eyebrow', 'BETWEEN GAME GRIP RESET');
    setText(how, '.ps-heading h2', 'YOUR PADDLE WAITS. YOUR GRIP RECOVERS.');
    setText(
      how,
      '.ps-heading > p:last-child',
      'Paddle Socks keep absorbent contact on the handle while you hydrate, reset and mentally delete the last rally.'
    );

    const cards = how.querySelectorAll('.ps-court-sequence article');
    setStep(
      cards[0],
      'COVER',
      'COVER THE GRIP.',
      'Full grip coverage the moment play stops.'
    );
    setStep(
      cards[1],
      'RECOVER',
      'RESET BETWEEN MATCHES.',
      'Hydrate and refocus while microfiber stays in contact with the grip.'
    );
    setStep(
      cards[2],
      'RETURN',
      'COME BACK WITH PRO FEEL.',
      'Remove before play and return with a drier, more consistent handle. No towel ceremony.'
    );
  }

  const techCards = document.querySelectorAll('.ps-tech-card');
  const densityCopy = techCards[1]?.querySelector('div > p:last-child');
  if (densityCopy) {
    densityCopy.textContent = '420 GSM equivalent up top. 500 below near the base of the grip.';
  }

  document.querySelectorAll('.ps-material-strip').forEach((strip) => strip.remove());

  const contact = document.querySelector('.ps-contact');
  if (contact) {
    setText(contact, '.ps-contact__copy .ps-eyebrow', 'PRO SHOPS, TOURS AND COLLABS');
    setText(contact, '.ps-contact__copy h2', 'BRING PADDLE SOCKS COURTSIDE.');
    setText(
      contact,
      '.ps-contact__copy > p:last-child',
      'For pro shops, tournaments and teams that sweat the details. Tell us what you are building. We will handle the grip part.'
    );
    setText(contact, '.ps-contact__cta span', 'TALK SHOP');
    setText(contact, '.ps-contact__cta small', 'OPEN CONTACT FORM');
  }
})();
